<template>
    <o-modal @close="handleCancel" modalClass="info-modal-modern">
        <template v-slot:header>
            <div class="modal-header-title">
                <i class="fas fa-ticket-alt header-icon"></i>
                <span>{{ voucherRedeem.cardTitle }}</span>
            </div>
        </template>
        <template v-slot:body>
            <div v-if="voucherRedeem.isLoading" class="loading-state">
                <i class="fas fa-spinner fa-spin spinner-icon"></i>
                <span>Loading information...</span>
            </div>
            <o-form v-else autocomplete="off" class="info-form-wrapper">
                <o-form-group title="" name="info" :label="false" class="m-0 p-0">
                    <div class="info-content-card">
                        <!-- Header Status Summary -->
                        <div class="info-status-bar" :class="statusClass">
                            <div class="status-info">
                                <span class="status-badge" :class="statusBadgeClass">{{ statusText }}</span>
                                <span class="status-subtext" v-if="voucherRedeem.claimed_at">Claimed on {{ voucherRedeem.claimed_at }}</span>
                                <span class="status-subtext text-danger" v-else-if="voucherRedeem.cancelled_at">Cancelled on {{ voucherRedeem.cancelled_at }}</span>
                                <span class="status-subtext text-danger" v-else-if="isExpired">Expired on {{ voucherRedeem.expired_at }}</span>
                                <span class="status-subtext" v-else>Expires on {{ voucherRedeem.expired_at }}</span>
                            </div>
                        </div>

                        <!-- Info Grid (2 Columns) -->
                        <div class="info-grid">
                            <!-- Member Info -->
                            <div class="form-sub-item full-width">
                                <label><i class="fas fa-user me-1"></i> Member Name</label>
                                <o-input-text name="member_name" v-model="voucherRedeem.member_name" readonly />
                            </div>

                            <!-- Voucher Info -->
                            <div class="form-sub-item">
                                <label><i class="fas fa-tag me-1"></i> Voucher Name</label>
                                <o-input-text name="voucher_name" v-model="voucherRedeem.voucher_name" readonly />
                            </div>

                            <div class="form-sub-item">
                                <label><i class="fas fa-store me-1"></i> Provided By</label>
                                <o-input-text name="voucher_merchant_name" v-model="voucherRedeem.voucher_merchant_name" readonly />
                            </div>

                            <div class="form-sub-item" v-if="voucherRedeem.merchant_name">
                                <label><i class="fas fa-building me-1"></i> Claimed on Merchant</label>
                                <o-input-text name="merchant_name" v-model="voucherRedeem.merchant_name" readonly />
                            </div>

                            <!-- Dates -->
                            <div class="form-sub-item">
                                <label><i class="fas fa-calendar-alt me-1"></i> Expired Date</label>
                                <o-input-text name="expired_at" v-model="voucherRedeem.expired_at" readonly />
                            </div>

                            <div class="form-sub-item full-width" v-if="voucherRedeem.cancelled_reason">
                                <label><i class="fas fa-exclamation-triangle me-1"></i> Cancelled Reason</label>
                                <o-input-text name="cancelled_reason" v-model="voucherRedeem.cancelled_reason" readonly />
                            </div>
                        </div>
                    </div>

                    <!-- Footer Actions -->
                    <div class="form-footer">
                        <div class="footer-actions">
                            <button type="button" class="btn-cancel" @click="handleCancel">
                                Close
                            </button>
                        </div>
                    </div>
                </o-form-group>
            </o-form>
        </template>
    </o-modal>
</template>

<script>
import { OForm, OFormGroup, OInputText, OModal } from '@/components/OmnihControl';
import dayjs from 'dayjs';
import store from '@/store'

export default {
    name: 'VoucherRedeemInfo',
    components: {
        OForm,
        OFormGroup,
        OInputText,
        OModal
    },
    props: {
        isModal: {
            type: Boolean,
            default: false
        },
        redeemId: {
            type: String,
            default: null
        }
    },
    emits: ['cancel'],
    data: function() {
        return{
            items: [],
            voucherRedeem: ({
                voucher_name: '',
                member_name: '',
                voucher_merchant_name:'',
                merchant_name: '',
                expired_at: '',
                claimed_at: '',
                cancelled_at: '',
                cancelled_reason: '',
                disable: false,
                isLoading: false,
                cardTitle: 'Information Voucher Redeem',
                dataReady: false
            }),
            options: [],
            validation: [],
        }
    },
    computed: {
        currentRouteName() {
            return this.$route.name;
        },
        isExpired() {
            if (this.voucherRedeem.claimed_at || this.voucherRedeem.cancelled_at) return false;
            if (!this.voucherRedeem.raw_expired_at) return false;
            let dateStr = String(this.voucherRedeem.raw_expired_at);
            if (dateStr.indexOf('T') === -1 && dateStr.length === 19) {
                dateStr = dateStr.replace(' ', 'T');
            }
            return new Date(dateStr) < new Date();
        },
        statusText() {
            if (this.voucherRedeem.cancelled_at) return 'Cancelled';
            if (this.voucherRedeem.claimed_at) return 'Claimed';
            if (this.isExpired) return 'Expired';
            return 'Active';
        },
        statusBadgeClass() {
            if (this.voucherRedeem.cancelled_at || this.isExpired) return 'badge-cancelled';
            if (this.voucherRedeem.claimed_at) return 'badge-claimed';
            return 'badge-claimed';
        },
        statusClass() {
            if (this.voucherRedeem.cancelled_at || this.isExpired) return 'status-bg-cancelled';
            if (this.voucherRedeem.claimed_at) return 'status-bg-claimed';
            return 'status-bg-active';
        }
    },
    async mounted() {
        const id = this.redeemId || this.$route.params.id;
        if (id) {
            this.loadState(id);
        }
    },
    methods:{
        async loadState(id){
            this.voucherRedeem.isLoading = true;
            store.dispatch('VoucherRedeem/read_single',id).then((data)=>{                
                this.voucherRedeem.id = data.id
                this.voucherRedeem.voucher_name = data.voucher.name;
                this.voucherRedeem.member_name = `${data.member.title} ${data.member.first_name} ${data.member.last_name}`;
                this.voucherRedeem.merchant_name = data.merchant_name;
                this.voucherRedeem.voucher_merchant_name = data.voucher?.provider_name || data.voucher?.corporate_name || data.voucher?.merchant_name || data.voucher?.merchant?.name || '';
                this.voucherRedeem.raw_expired_at = data.expired_at;
                this.voucherRedeem.expired_at = this.formatDate(data.expired_at, false);

                if (data.claimed_at) {
                    this.voucherRedeem.claimed_at = this.formatDate(data.claimed_at, false);
                } else {
                    this.voucherRedeem.claimed_at = '';
                }
                
                if (data.cancelled_at) {
                    this.voucherRedeem.cancelled_at = this.formatDate(data.cancelled_at, false);
                } else {
                    this.voucherRedeem.cancelled_at = '';
                }
                this.voucherRedeem.cancelled_reason = data.reason;
                this.voucherRedeem.disable = true;     
            })
            .finally(()=>{
                this.voucherRedeem.isLoading = false;
            })
        },
        formatDate(dateString, isUTC = false) {
            if (!dateString) return '';
            let dateStr = String(dateString);
            if (dateStr.indexOf('T') === -1 && dateStr.indexOf('Z') === -1 && dateStr.length === 19) {
                dateStr = dateStr.replace(' ', 'T');
                if (isUTC) dateStr += 'Z';
            } else if (isUTC && dateStr.indexOf('Z') === -1 && !dateStr.includes('+')) {
                dateStr += 'Z';
            }
            const dateObj = new Date(dateStr);
            if (isNaN(dateObj.getTime())) {
                return dayjs(dateString).format('dddd [at] MMM DD, YYYY, h:mm:ss A');
            }
            return dayjs(dateObj).format('dddd [at] MMM DD, YYYY, h:mm:ss A');
        },
        handleCancel() {
            this.$emit('cancel');
        }
    }
}
</script>

<!-- Non-scoped: required because OModal teleports to <body> -->
<style>
    .info-modal-modern {
        max-width: 640px !important;
        width: 95vw !important;
        font-family: 'Inter', sans-serif;
        max-height: 88vh !important;
        display: flex !important;
        flex-direction: column !important;
    }

    .info-modal-modern .omni-modal-body {
        overflow: hidden !important;
        display: flex !important;
        flex-direction: column !important;
        flex: 1 !important;
        min-height: 0 !important;
        padding: 16px 24px 20px 24px !important;
    }

    .info-modal-modern .form-group {
        margin-bottom: 0 !important;
    }
</style>

<style scoped>
    .modal-header-title {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 16px;
        font-weight: 700;
        color: #1e293b;
    }

    .header-icon {
        color: var(--primary-color, #F27178);
    }

    .loading-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 60px 0;
        gap: 12px;
        color: #64748b;
        font-size: 14px;
    }

    .spinner-icon {
        font-size: 24px;
        color: var(--primary-color, #F27178);
    }

    .info-form-wrapper {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
    }

    .info-content-card {
        border: 1px solid #E2E8F0;
        border-radius: 12px;
        background: #FFFFFF;
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 18px;
        max-height: calc(85vh - 160px);
        overflow-y: auto;
    }

    /* Status Bar */
    .info-status-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 16px;
        border-radius: 8px;
        border: 1px solid #E2E8F0;
    }

    .status-bg-claimed {
        background: var(--secondary-color, #EFF6FF);
        border-color: var(--primary-color, #DBEAFE);
    }

    .status-bg-cancelled {
        background: var(--danger-bg, #FEF2F2);
        border-color: var(--danger-bg, #FEE2E2);
    }

    .status-info {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .status-badge {
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        padding: 4px 10px;
        border-radius: 6px;
    }

    .badge-claimed {
        background: var(--primary-color, #2563EB);
        color: var(--secondary-color, white);
    }

    .badge-cancelled {
        background: var(--danger-color, #DC2626);
        color: white;
    }

    .status-subtext {
        font-size: 13px;
        color: var(--primary-color, #475569);
        font-weight: 500;
    }

    .status-subtext.text-danger {
        color: var(--danger-color, #dc2626) !important;
    }

    /* Grid Layout */
    .info-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 14px 16px;
    }

    .form-sub-item {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .form-sub-item.full-width {
        grid-column: span 2;
    }

    .form-sub-item label {
        display: flex;
        align-items: center;
        font-size: 11px;
        font-weight: 700;
        color: #64748B;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin: 0;
    }

    /* Inputs */
    :deep(.input-wrapper),
    :deep(.o-input-text) {
        margin: 0 !important;
    }

    :deep(input.form-control),
    :deep(.input-wrapper input) {
        width: 100%;
        padding: 10px 14px !important;
        border: 1.5px solid #E2E8F0 !important;
        border-radius: 8px !important;
        font-size: 14px !important;
        color: #0F172A !important;
        background-color: #F8FAFC !important;
        transition: all 0.2s;
    }

    :deep(input.form-control[readonly]),
    :deep(.input-wrapper input[readonly]),
    :deep(input.form-control:disabled),
    :deep(.input-wrapper input:disabled) {
        background-color: #F8FAFC !important;
        color: #334155 !important;
        border-color: #E2E8F0 !important;
        cursor: default;
    }

    /* Footer */
    .form-footer {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        padding: 16px 24px 20px 24px;
        margin-left: -24px;
        margin-right: -24px;
        margin-bottom: -20px;
        margin-top: 16px;
        background: #ffffff;
        z-index: 10;
        border-top: 1px solid #E5E5E5;
        flex-shrink: 0;
    }

    .footer-actions {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .btn-cancel {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 20px;
        height: 42px;
        min-width: 100px;
        background: #FFFFFF;
        border: 1px solid #D4D4D4;
        box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
        border-radius: 8px;
        font-family: 'Inter', sans-serif;
        font-weight: 600;
        font-size: 14px;
        color: #404040;
        cursor: pointer;
        transition: background 0.15s;
    }

    .btn-cancel:hover {
        background: #f9fafb;
    }

    @media (max-width: 640px) {
        .info-grid {
            grid-template-columns: 1fr;
        }

        .form-sub-item.full-width {
            grid-column: span 1;
        }
    }
</style>